export type Pair<T> = [T, T];

export type Point = Pair<number>;

export function subtractPoints(point1: Point, point2: Point): Point {
    return [
        point1[X] - point2[X],
        point1[Y] - point2[Y]
    ];
}
export function addPoints(point1: Point, point2: Point): Point {
    return [
        point1[X] + point2[X],
        point1[Y] + point2[Y]
    ];
}

export function clampPoint(point: Point, boundaries: Pair<Point>): Point {
    return [
        Math.min(
            Math.max(point[X], boundaries[START][X]),
            boundaries[END][X]
        ),
        Math.min(
            Math.max(point[Y], boundaries[START][Y]),
            boundaries[END][Y]
        )
    ];
}

export enum Dimension {
    X = 0,
    Y = 1
}
export function otherDimension(dim: Dimension): Dimension {
    return dim === Dimension.X ? Dimension.Y : Dimension.X;
}

export interface BoxDimensions {
    pos: Point;
    size: Point;
}

export const X = 0;
export const Y = 1;

export const START = 0;
export const END   = 1;

export type UnitValueCalculator = (totalPixels: number) => number;
export function pixels(value: number): UnitValueCalculator {
    return () => value;
}
export function factor(value: number): UnitValueCalculator {
    return (totalPixels: number) => Math.round(totalPixels * value);
}

export enum QuadrangleVertex {
    TOP_LEFT     = 0,
    TOP_RIGHT    = 1,
    BOTTOM_LEFT  = 2,
    BOTTOM_RIGHT = 3
}
export type QuadrangleVertices = [Point, Point, Point, Point];
